import { productSelectors } from '@ynap/product-state';
import { createSelector } from 'reselect';
import { default as getSelectedCategory } from './getSelectedCategory';

const { getMappedProducts } = productSelectors;

const mapProductSiblings = (products, siblings, baseUrl) => {
    const hasColour = (colourPartNumber, colours) => colours.some((c) => c.partNumber === colourPartNumber);

    return products.map((product) => {
        const siblingProduct = siblings?.find((ps) => ps?.modelId === product?.modelId && hasColour(product.partNumber, ps.productColours));

        const productSiblings = siblingProduct?.productColours?.map((colour) => {
            const imageUrl = new URL(baseUrl);
            return {
                ...colour,
                imageViews: colour.imageViews || ['in'],
                imageTemplate: colour.imageTemplate || `//${imageUrl.hostname}/variants/images/${colour.partNumber}/{view}/w{width}.jpg`,
            };
        });

        return {
            ...product,
            productSiblings,
        };
    });
};

export const getProductsInternal = (error, visibleProducts, config, locale, pageType, messages, loadingRequest, user, siblings) => {
    if (error || !visibleProducts) {
        return null;
    }

    const badgeBlocklistString = config.head.plp?.badgeBlocklist;
    const badgeBlocklistArray = badgeBlocklistString?.split(',');
    const appProductConfig = {
        pdpUrlTemplate: config.global.urlConfig.pdp.construct,
        badgeBlocklist: badgeBlocklistArray,
        locale,
        availableImageSizes: config.head.plpAvailableImageSizes,
        imageQuality: config.head.imageQualityPercentage,
        saleBadges: config.global.application?.saleBadges,
        imagesphereAspectRatio: config.head.aspectRatio?.imagesphere,
        plpImageSrcSet: config.head.plpImageSrcSet,
    };
    const useIdentifier = config.head.useIdentifier;
    const baseUrl = config.head.seo.baseUrl;

    return visibleProducts.map((pl) => {
        const mappedProducts = getMappedProducts(pl.products, appProductConfig, pageType, messages, useIdentifier, config, user);
        const productsWithSiblings = mapProductSiblings(mappedProducts, siblings, baseUrl);

        return {
            key: pl.key,
            loading: loadingRequest || pl.loading,
            products: productsWithSiblings,
        };
    });
};

export default createSelector(
    [
        (state) => state.plp?.listing?.error,
        (state) => state.plp?.listing?.visibleProducts,
        (state) => state.config,
        (state) => state.appState?.locale,
        (state, props) => getSelectedCategory(state, props?.routeKey)?.pageType,
        (state, props) => props.messages,
        (state, props, loadingState) => loadingState?.loadingRequest,
        (state) => state.userState,
        (state) => state.plp?.listing?.siblingsProducts?.products,
    ],
    getProductsInternal,
);
